import React, { useState } from "react";
import { Editor } from "@tinymce/tinymce-react";
import axios from "axios";

const TextEditor = ({
    setOuterContent,
    setOuterTitle,
    initialContentValue = "",
    initialTitleValue = "",
}) => {
    const [content, setContent] = useState(initialContentValue);
    const [title, setTitle] = useState(initialTitleValue);

    const handleEditorChange = (content) => {
        setContent(content);
        setOuterContent(content);
    };

    const handleTitleChange = (event) => {
        setTitle(event.target.value);
        setOuterTitle(event.target.value);
    };

    return (
        <div className="container-fluid">
            <input
                type="text"
                value={title}
                onChange={handleTitleChange}
                className="form-control mb-3"
                placeholder="Başlık"
            />
            <Editor
                apiKey="4j9q8h2r0dbtso75my62pmeg493ek76i010d7zb7p5ius0dd"
                value={content}
                onEditorChange={handleEditorChange}
                init={{
                    plugins: "table image link lists advlist code", // add 'code' here
                    toolbar:
                        "undo redo | formatselect | bold italic underline | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | table | image link | code", // add 'code' here
                    directionality: "ltr",
                    content_style:
                        "body { font-family:Helvetica,Arial,sans-serif; font-size:14px }",
                    images_upload_handler: (blobInfo) => {
                        return new Promise(async (resolve, reject) => {
                            try {
                                const formData = new FormData();
                                formData.append("file", blobInfo.blob(), blobInfo.filename());

                                const response = await axios.post(`${process.env.REACT_APP_API_URL}/admin/blogs/image/upload`, formData, {
                                    headers: {
                                        'Content-Type': 'multipart/form-data',
                                    },
                                });

                                if (response.status === 200) {
                                    const { location } = response.data;
                                    console.log("Image uploaded successfully:", location);
                                    resolve(location); // Resolve with the image URL
                                } else {
                                    console.log("Failed to upload image.");
                                    reject(new Error("Failed to upload image.")); // Reject with an error
                                }
                            } catch (error) {
                                console.error("An error occurred while uploading the image:", error);
                                reject(new Error("An error occurred while uploading the image.")); // Reject with an error
                            }
                        });
                    },
                }}
            />
            <div className="mt-5">
                <h3>Örnek Gösterim:</h3>
                <div
                    className="container text-start border blog-section"
                    dangerouslySetInnerHTML={{ __html: content }}
                />
            </div>
        </div>
    );
};

export default TextEditor;
